module.exports = __webpack_public_path__ + "img/realtime.36857a6d.svg";